<template>
    <div>
        <el-dialog v-model="addQuestionShow" :close-on-click-modal="false" :align-center="true" title="Tips" width="500"
            :show-close="false">
            <template #header>
                <div class="header">提问</div>
                <div class="close_icon cursor_pointer" @click="closePopup">
                    <el-icon :size="24">
                        <Close />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content p-20">
                <div class="flex Flexalign">
                    <div>问题类型</div>
                    <el-select class="ml-30" v-model="questionQuery.askCategoryCode" placeholder="请选择问题类型"
                        style="width: 240px">
                        <el-option v-for="item in questionTypeList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </el-select>
                </div>
                <div class="question_content flex flexcolumn mt-20 flex-1">
                    <el-input v-model="questionQuery.askContent"
                        style="width: 100%; min-height: 200px;max-height: 300px;overflow: auto;" autosize
                        type="textarea" placeholder="有什么问题可以向伴学师提问？" />
                </div>
                <div class="mt-15 upload_box">
                    <el-upload class="upload-demo" v-model:file-list="fileList" drag :action="uploadUrl" multiple
                        :on-preview="handlePreview" list-type="picture" :on-progress="handleUploadProgress"
                        :on-success="handleUploadSuccess" :on-error="handleUploadError" :on-change="handleFileChange">
                        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                        <div class="el-upload__text"><em>点击上传附件</em></div>
                        <!-- 自定义文件列表项 -->
                        <template #file="{ file }">
                            <div class="custom-file-item">
                                <!-- 统一缩略图图标 -->
                                <div class="file-thumbnail">
                                    <el-image v-if="isImage(file)" class="img_box"
                                        :src="file.response?.data?.url"></el-image>
                                    <el-icon v-else>
                                        <Document />
                                    </el-icon>
                                </div>

                                <!-- 文件名 -->
                                <span class="file-name">{{ file.name }}</span>

                                <!-- 状态图标（成功显示√，悬停显示×） -->
                                <div class="file-actions">
                                    <el-icon v-if="file.status === 'success'" class="success-icon">
                                        <CircleCheck />
                                    </el-icon>
                                    <el-icon v-if="file.status === 'success'" class="delete-icon"
                                        @click.stop="handleRemove(file)">
                                        <CircleClose />
                                    </el-icon>
                                </div>
                            </div>
                        </template>
                    </el-upload>
                </div>
                <div class="btn_list mt-20 flex Flexalign">
                    <div class="btn_cancel cursor_pointer">取消</div>
                    <div class="btn_cancel btn_confirm cursor_pointer ml-20" @click="confirmAsk">确定</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as config from "@/config/config";
import { mapState } from "vuex";
export default {
    name: "GjkcH5AddQuestion",
    props: {
        companionTeacherInfo: {},
        courseDetail:{}
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.userInfo,
            selectLearningInfo: (state) => state.learning.selectLearningInfo,
        }),
    },

    data() {
        return {
            addQuestionShow: false,
            questionTypeList: [],
            questionQuery: {
                buyerUserId: '',  // 学生id
                courseId: '',  // 课程id
                tutorId: '',  // 伴学师id
                askCategoryCode: '',  // 提问问题类型
                askContent: '',  // 问题内容
                askTime: '',  // 提问时间
                askAttach: [
                    {
                        originalName: '',   // 初始附件名
                        name: '',  //显示文件名 (可修改)
                        url: '',  // 文件URL
                        size: '',  // 文件大小
                        mimeType: '',  // 文件类型
                        ext: '',  // 文件扩展名
                        uploadTime: '',  // 上传时间
                    }
                ],
                otherrule: {

                }
            },
            fileList: [],
            uploadUrl: "",
            isUploading: false, // 全局上传状态
            uploadProgress: 0, // 总进度百分比
            activeUploads: new Set(), // 记录正在上传的文件ID
            loading: {}, // loading
        };
    },

    mounted() {
        this.getDictList();
        this.uploadUrl = config.COMMON_UPLOAD_URL;
        this.initQuestionQuery();
    },

    methods: {
        closePopup() {
            this.addQuestionShow = false;
            this.initQuestionQuery();
        },
        initQuestionQuery() {
            this.questionQuery = {
                buyerUserId: this.userInfo.buyerUserId,  // 学生id
                courseId: this.courseDetail.courseId,  // 课程id
                tutorId: this.companionTeacherInfo.tutorId,  // 伴学师id
                askCategoryCode: '',  // 提问问题类型
                askContent: '',  // 问题内容
                askTime: '',  // 提问时间
                askAttach: [
                    {
                        originalName: '',   // 初始附件名
                        name: '',  //显示文件名 (可修改)
                        url: '',  // 文件URL
                        size: '',  // 文件大小
                        mimeType: '',  // 文件类型
                        ext: '',  // 文件扩展名
                        uploadTime: '',  // 上传时间
                    }
                ],
                otherrule: {

                }
            }
            this.fileList = [];
        },
        // 获取反馈类型字典
        getDictList() {
            this.$Api.common.getDictList({ dictName: 'askCategoryCode' }).then(res => {
                this.questionTypeList = res.data.data.map(item => {
                    return { label: item.dictName, value: item.dictId }
                });
            }).catch(() => { })
        },
        // 文件加入队列时触发
        handleFileChange(file) {
            if (file.status === "ready") {
                this.activeUploads.add(file.uid);
                this.isUploading = true;
                this.loading = this.$Dialog.loading("文件上传中...");
            }
        },

        // 上传进度更新（支持多文件）
        handleUploadProgress(event, file) {
            const totalSize = this.fileList.reduce((sum, f) => sum + f.size, 0);
            const loadedSize = this.fileList.reduce((sum, f) => {
                return sum + (f.uid === file.uid ? event.loaded : f.size);
            }, 0);
            this.uploadProgress = Math.round((loadedSize / totalSize) * 100);
        },

        // 单个文件上传成功
        handleUploadSuccess(response, file) {
            // 此处要判断是否是上传成功，超出文件大小限制的要去掉
            if (this.$Tools.empty(response.data)) {
                this.$message.error(`${response.message}`);
                // 删除上传失败的原生
                this.fileList.pop();
            }
            this.activeUploads.delete(file.uid);
            this.checkAllUploaded();
        },

        // 单个文件上传失败
        handleUploadError(err, file) {
            this.activeUploads.delete(file.uid);
            this.checkAllUploaded();
            this.$message.error(`${file.name} 上传失败，请重试`);
        },
        // 文件删除处理
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            if (index !== -1) {
                this.fileList.splice(index, 1);
            }
        },
        handlePreview(file) {
            console.log(file);
        },

        isImage(file) {
            return (
                file.raw?.type?.startsWith("image/") ||
                /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name)
            );
        },
        // 检查所有文件是否完成
        checkAllUploaded() {
            if (this.activeUploads.size === 0) {
                this.isUploading = false;
                this.uploadProgress = 0;
                // if(!this.$Tools.empty(this.loading)){
                // }
            }
            // 清除loading
            this.loading.close();
            this.loading = {};
        },
        // 确认
        confirmAsk() {
            if (this.$Tools.empty(this.questionQuery.askCategoryCode)) {
                this.$Dialog.toast("请选择问题类型", { type: 'warning' });
                return
            }
            if (this.$Tools.empty(this.questionQuery.askContent)) {
                this.$Dialog.toast("请填写你要询问的问题内容", { type: 'warning' });
                return
            }
            if (this.$Tools.empty(this.questionQuery.tutorId)) {
                if (this.companionTeacherInfo.tutorId) {
                    this.questionQuery.tutorId = this.companionTeacherInfo.tutorId;
                    this.questionQuery.courseId = this.courseDetail.courseId;
                } else {
                    this.$Dialog.toast("暂无可询问的规划师，请稍后再尝试", { type: 'warning' });
                    return
                }
            }
            this.questionQuery.askAttach = this.fileList.map(item => {
                return {
                    originalName: item.name,
                    name: item.name,
                    size: item.raw?.size,
                    mimeType: item.raw?.type,
                    url: item.response?.data?.url,
                }
            })
            this.$Api.course.askQuestionByTeacher(this.questionQuery).then(() => {
                this.closePopup();
                this.$Dialog.toast('提问成功，请耐心等待规划师的答复');
            }).catch(() => { })
        }
    },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 20px 20px 10px 10px;
    padding: 0;
    width: 663px;
    min-height: 596px;
    position: relative;
    max-height: 800px;
    overflow-y: auto;
}

:deep(.el-dialog__header) {
    position: relative;
}

.header {
    text-align: left;
    font-weight: bold;
    font-size: 20px;
    color: #111111;
    line-height: 60px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-left: 20px;
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
}

.dialog_content {
    font-size: 14px;
    color: #303030;

    .companion_teacher_question {
        width: 100px;
        height: 100px;
    }

    .question_content {
        width: 100%;
        min-height: 117px;
        background: #f7f7f7;
        border-radius: 10px;
        position: relative;
        padding: 10px 0;

        :deep(.el-textarea__inner) {
            background: #f7f7f7;
            box-shadow: none;
            resize: none;
        }
    }

    .btn_list {
        justify-content: end;

        .btn_cancel {
            width: 100px;
            height: 46px;
            border-radius: 26px;
            border: 1px solid #989898;
            line-height: 46px;
            text-align: center;
            color: #989898;
            box-sizing: border-box;
        }

        .btn_confirm {
            border: none;
            background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
            color: #fff;
        }
    }

    .custom-file-item {
        position: relative;
        display: flex;
        align-items: center;
        padding: 8px;
        // border: 1px solid #e4e7ed;
        width: 100%;
        margin-bottom: 5px;
        border-radius: 4px;
    }

    .file-thumbnail {
        margin-right: 10px;
        font-size: 24px;
        color: #409eff;
    }

    .file-name {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .file-actions {
        position: absolute;
        top: -8px;
        right: -8px;
    }

    .success-icon {
        color: #67c23a;
        font-size: 16px;
        background: white;
        border-radius: 50%;
    }

    .delete-icon {
        display: none;
        color: #f56c6c;
        font-size: 16px;
        background: white;
        border-radius: 50%;
        cursor: pointer;
    }

    .custom-file-item:hover .delete-icon {
        display: block;
    }

    .custom-file-item:hover .success-icon {
        display: none;
    }

    .img_box {
        width: 60px;
        height: 60px;
        border-radius: 10px;
    }
}
</style>